<template>
  <!-- 신규 클래스: autoplay-cell -->
  <!-- 인스턴트 플레이 시에 playing 클래스 추가 필요 -->
  <div class="thumb autoplay-cell" ref="cell"
       @click.prevent="(e)=>goDetailWithFilter(cellInfo, e)"
       @mouseenter.prevent="enterMouse" @mouseleave.prevent="leaveMouse"
       style="cursor:pointer">
    <!--  <div class="thumb autoplay-cell playing">-->
    <div class="btn-ui">
      <template v-if="!isLoading && !isPause">
        <button class="btn-volume-off" v-if="isPlayerMute" @click.prevent="()=>setMuteState(false)">volume off</button>
        <button class="btn-volume-on" v-else @click.prevent="()=>setMuteState(true)">volume on</button>
      </template>
    </div>

    <div :class="isShowSpinner ? 'spinner on' : 'spinner'">
      <div class="loading">loading</div>
    </div>
    <div class="video-area-wrap">
      <div class="video-area" ref="player"></div>
      <age-limits :target-age="targetAge" :age-tag="ageTag"/>
    </div>
    <div class="thumb-image">
      <a href="#" aria-labelledby="autopley-cell-title-1-1 autopley-cell-title-1-2">
        <div class="picture-area">
          <WebpImage :imageInfo="{imageUrl: cellInfo.thumbnail, width: thumbnailInfo.width, height: thumbnailInfo.height, alt: altTitle, className: 'thumb-img'}"/>
        </div>
      </a>
      <ul class="tag-top tag-list"></ul>
      <age-limits :target-age="targetAge" :age-tag="ageTag"/>
      <ul class="badge-list">
        <li class="left-top-area">
          <ul v-top-tag-list="topTagList"></ul>
        </li>
        <li class="right-top-area" v-common-tag-list="{'badgeList': brandTagList, 'type': 'brand'}"></li>
      </ul>
    </div>
    <div class="sub-title">
      <div class="sub-right" ref="title" v-title-list="{ 'titleList': cellInfo.title_list, 'cellType': 'landscape' }"/>
      <div class="sub-btn">
        <btn-zzim-with-event :is-on="zzim" :icon-only="true" :event-list="eventList"/>
      </div>
    </div>
  </div>
</template>

<script>
import { resizeThumbnail } from '@/common/utils/image'
import _ from 'lodash'
import CellMixIn from '@/mixins/cell.mixin'
import { titleList, topTagList, commonTagList } from '@/common/resources/directives'
import cookie from '@/common/utils/cookie'
import { EVENT_TYPE_MOUSE_ENTER, EVENT_TYPE_MOUSE_LEAVE } from '@/common/resources/const'
import { CellEventMapper } from '@/common/utils/gnb.fp'
import BtnZzimWithEvent from '@/components/button/BtnZzimWithEvent'
import AgeLimits from '@/components/model/AgeLimits'
import { previewPlayableBrowser, getUserInfo } from '@/common/utils/common'
import WebpImage from '@/components/image/WebpImage'

export default {
  name: 'PreviewInstantPlayerCell.vue',
  components: { WebpImage, BtnZzimWithEvent, AgeLimits },
  mixins: [
    CellMixIn
  ],
  directives: {
    titleList,
    topTagList,
    commonTagList
  },
  data () {
    return {
      isPooqzone: cookie.isWavveOn(),
      zzim: 'n',
      contentType: '',
      contentId: '',
      player: null,
      isLoading: false,
      isShowSpinner: false,
      isPause: false
    }
  },
  props: {
    cellInfo: {
      type: Object
    },
    thumbnailInfo: {
      type: Object
    },
    isPlayerMute: {
      type: Boolean
    },
    setPlayerMuteStateFn: {
      type: Function
    }
  },
  methods: {
    getSrc () {
      return resizeThumbnail(this.cellInfo.thumbnail, {
        width: this.thumbnailInfo.width,
        height: this.thumbnailInfo.height
      })
    },
    goDetailWithFilter (cellInfo, e) {
      const buttonType = e.target.getAttribute('data-button-type') || 'none'
      const classStr = e.target.getAttribute('class') || ''
      const isVolumeButton = classStr.indexOf('btn-volume-off') > -1 || classStr.indexOf('btn-volume-on') > -1
      if (isVolumeButton) {
        e.preventDefault()
        return
      }
      if (buttonType === 'none') {
        this.goDetail(cellInfo)
      }
    },
    enterMouse () {
      if (previewPlayableBrowser()) {
        this.$previewEvents.$emit(EVENT_TYPE_MOUSE_ENTER, this)
      }
    },
    leaveMouse () {
      if (previewPlayableBrowser()) {
        this.$previewEvents.$emit(EVENT_TYPE_MOUSE_LEAVE, this)
      }
    },
    setMuteState (isMute) {
      this.setPlayerMuteStateFn(isMute)
      this.player.setMute(isMute)
    },
    initialize () {
      this.zzim = _.get(this.cellInfo, 'iszzim', 'n')
    },
    goDetailPage (cellInfo) {
      if (this.player && this.player.destructor) {
        this.player.destructor()
      }
      this.goDetail(cellInfo)
    },
    async enableVideoMode () {
      if (this.player !== null) return
      if (!this.$refs.cell) return
      this.isLoading = true
      const spinnerTimer = setTimeout(() => {
        this.isShowSpinner = true
      }, 500)
      this.player = null
      this.$refs.cell.classList.add('video-mode')
      this.$refs.cell.parentNode.classList.add('expand')
      try {
        let Player = await import(/* webpackChunkName:'instantPlayer' */ '@/common/player/scalableplayer')
        // eslint-disable-next-line new-cap
        this.player = new Player.default(this.$refs.player, 'i', 'i')
      } catch (e) {
        this.player = null
      }
      if (!this.player) return
      this.player.setInitImage(this.getSrc())
      this.player.setTimeoutCallback(() => {
        this.isPause = true
      })
      this.player.setLoadedCallback(() => {
        if (this.player === null || !(this.$refs && this.$refs.cell)) return
        this.isLoading = false
        this.isPause = false
        clearTimeout(spinnerTimer)
        this.isShowSpinner = false
        this.$refs.cell.classList.add('playing')
        this.player.setMute(this.isPlayerMute)
      })
      this.player.setErrorCallback(() => {
        this.disableVideoMode()
      })
      const meta = this.getInstancePlayMeta()
      if (meta.contentType.toUpperCase() === 'LIVE') {
        this.player.load(meta.contentType, meta.contentId)
      } else {
        getUserInfo().then((userInfo) => {
          this.player.setUserInfo(userInfo)
          this.player.load(meta.contentType, meta.contentId)
        }).catch(() => {
          this.player.load(meta.contentType, meta.contentId)
        })
      }
    },
    disableVideoMode () {
      if (this.$refs.cell && this.$refs.cell.parentNode) {
        this.$refs.cell.parentNode.classList.remove('expand')
      }
      this.isLoading = false
      this.isShowSpinner = false
      if (this.player !== null) {
        this.player.destructor()
        this.player = null
      }
      if (this.$refs.cell && this.$refs.cell.classList) {
        this.$refs.cell.classList.remove('video-mode')
        this.$refs.cell.classList.remove('playing')
      }
    },
    getInstancePlayMeta () {
      const { onInstantPlay } = CellEventMapper(_.get(this.cellInfo, 'event_list', []))
      return {
        contentType: _.get(onInstantPlay, 'contenttype', ''),
        contentId: _.get(onInstantPlay, 'contentid', '')
      }
    }
  },
  computed: {
    imgSrc () {
      return resizeThumbnail(this.cellInfo.thumbnail, { width: this.thumbnailInfo.width, height: this.thumbnailInfo.height })
    },
    eventList () {
      return _.get(this.cellInfo, 'event_list', [])
    }
  },
  created () {
    this.initialize()
  },
  beforeDestroy () {
    this.disableVideoMode()
  }

}
</script>
<style scoped>
.spinner {
  display: none;
  position: absolute;
  top: 187px;
  right: 8px;
  bottom: auto;
  width: 30px;
  height: 30px;
  font-size: 0;
  text-indent: -99999px;
  animation-iteration-count: infinite;
  z-index: 100;
}
.spinner.on{
  display: block;
}
.loading{
  width: 30px;
  height: 30px;
  background: url(../../../assets/images/common/loading_white.png) no-repeat 0 0;
  background-size: cover;
  -webkit-animation: box 1s steps(12) infinite;
  -moz-animation: box 1s steps(12) infinite;
  animation: box 1s steps(12) infinite;
}
@-webkit-keyframes box {
  from {background-position:0 0}
  to   {background-position:-360px 0}
}

@-moz-keyframes box {
  from {background-position:0 0}
  to   {background-position:-360px 0}
}

@keyframes box {
  from {background-position:0 0}
  to   {background-position:-360px 0}
}
</style>
